import { AlpineComponent } from '@alpinejs/csp';

const EventTeaser = (): AlpineComponent => ({
  visible: false,
  handleIntersect() {
    this.visible = true;
  },
  getClassName() {
    return this.visible ? 'event-teaser--visible' : '';
  }
});

export default EventTeaser;
